import RetrievalDocumentUploadForm from "./RetrievalDocumentUploadForm";
import { uploadToADLS } from "../bondRetrievalUtils";
import { RETRIEVE_PII_ACCESS } from "./bondRetrieveSharedPropTypes";

const PROBATE_SECTIONS = [
  { label: "Court Order", name: "courtOrder" },
  { label: "Last Will and Testament", name: "lastWill" },
  { label: "Other Document", name: "otherDocument" },
  { label: "Cancellation Document", name: "cancellationDocument" },
  { label: "Endorsement Document", name: "endorsementDocument" },
  { label: "Endorsement POA Document", name: "endorsementPOADocument" },
  { label: "Bond Application", name: "bondApp" },
  { label: "Bond", name: "bond" },
  { label: "Indemnity Agreement", name: "indemnity" },
  { label: "Credit Report Document", name: "creditDocument" },
  { label: "FCRA Document", name: "fcraDocument" },
];

const PROBATE_INDEMNITY_VIEW_ROLES = new Set([
  "law_firm_user",
  "law_firm_admin",
  "professional_guardian",
  "professional guardian",
  "pg_contact",
  "carrier_team_member",
]);

const ProbateDocumentUpload = (props) => {
  const bondAmountNum =
    Number.parseFloat(props.globalData?.basicInformation?.bondAmount) || 0;
  const indemnityViewDisclaimer =
    bondAmountNum <= 50000 && PROBATE_INDEMNITY_VIEW_ROLES.has(props.role);

  return (
    <RetrievalDocumentUploadForm
      {...props}
      uploadToADLS={uploadToADLS}
      sections={PROBATE_SECTIONS}
      noteDisabled={false}
      indemnityViewDisclaimer={indemnityViewDisclaimer}
    />
  );
};

ProbateDocumentUpload.propTypes = RETRIEVE_PII_ACCESS;

export default ProbateDocumentUpload;
